import { createFileRoute, Link } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";
import { CheckCircle2 } from "lucide-react";

export const Route = createFileRoute("/_authenticated/sold-items")({
  head: () => ({ meta: [{ title: "Sold Items — Want To Buy" }] }),
  component: SoldItemsPage,
});

function SoldItemsPage() {
  return (
    <AppShell>
      <div className="mb-6">
        <h1 className="font-display text-3xl font-bold flex items-center gap-2">
          <CheckCircle2 className="h-7 w-7 text-primary" /> Sold Items
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Completed sales where you were the seller.</p>
      </div>

      <div className="panel p-10 text-center text-sm text-muted-foreground">
        <p>No sales yet.</p>
        <p className="mt-2">
          <Link to="/" className="text-primary hover:underline">Browse open buy orders</Link> and submit your first offer.
        </p>
      </div>
    </AppShell>
  );
}
